/**
 * Tokeniza cartão direto no pagar.me (nunca passa pelo nosso backend).
 * Docs: https://docs.pagar.me/reference/criar-token-de-cartao-1
 */

const PUBLIC_KEY = process.env.REACT_APP_PAGARME_PUBLIC_KEY;

export async function tokenizeCard({ number, holder_name, exp_month, exp_year, cvv }) {
  if (!PUBLIC_KEY) {
    throw new Error('Chave pública do pagar.me não configurada.');
  }

  const cleanNumber = (number || '').replace(/\s/g, '');
  const expMonth = parseInt(exp_month, 10);
  let expYear = parseInt(exp_year, 10);
  if (expYear < 100) expYear = 2000 + expYear;

  const payload = {
    type: 'card',
    card: {
      number: cleanNumber,
      holder_name: (holder_name || '').trim(),
      exp_month: expMonth,
      exp_year: expYear,
      cvv: (cvv || '').trim(),
    },
  };

  const r = await fetch(`https://api.pagar.me/core/v5/tokens?appId=${PUBLIC_KEY}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await r.json();
  if (!r.ok) {
    const msg = data?.errors ? Object.values(data.errors).flat().join('; ') : (data?.message || 'Falha ao validar cartão');
    throw new Error(msg);
  }

  return {
    token: data.id,
    last4: cleanNumber.slice(-4),
    brand: data.card?.brand || null,
  };
}
